export const myPlanogramQuery = (numberOfFacings, jurisdiction) => {
    const btwQuery = {
        operator: 'and',
        value: [
            {
                value: numberOfFacings,
                operator: 'gte',
                property: 'retailerGroup.maxFacings',
            },
            {
                value: numberOfFacings,
                operator: 'lte',
                property: 'retailerGroup.minFacings',
            },
        ],
    };

    const maxNullQuery = {
        operator: 'and',
        value: [
            {
                operator: 'null',
                property: 'retailerGroup.maxFacings',
            },
            {
                value: numberOfFacings,
                operator: 'lte',
                property: 'retailerGroup.minFacings',
            },
        ],
    };
    const orQuery = {
        operator: 'or',
        value: [btwQuery, maxNullQuery],
    };

    const finalQueryArray = [orQuery, getIsActiveQuery()];
    if (jurisdiction) {
        finalQueryArray.push(getJurisdictionQuery(jurisdiction.code));
    }
    return {
        operator: 'and',
        value: finalQueryArray,
    };
};
export const getIsActiveQuery = () => {
    return {
        value: true,
        operator: 'eq',
        property: 'isActive',
    };
};
export const getJurisdictionQuery = (id) => {
    return {
        value: id,
        operator: 'eq',
        property: 'retailerGroup.jurisdictionCode',
    };
};

export const getCurrentStatusQuery = () => {
    const startQuery = {
        value: getCurrentDate(),
        operator: 'lte',
        property: 'startDate',
    };
    const endQuery = {
        value: getCurrentDate(),
        operator: 'gte',
        property: 'endDate',
    };
    const innerQuery = {
        operator: 'and',
        value: [startQuery, endQuery],
    };
    return innerQuery;
};
export const getUpcomingQuery = () => {
    const innerQuery = {
        value: getCurrentDate(),
        operator: 'gt',
        property: 'startDate',
    };
    return innerQuery;
};
export const getPreviousQuery = () => {
    const innerQuery = {
        value: getCurrentDate(),
        operator: 'lt',
        property: 'endDate',
    };
    return innerQuery;
};

const getCurrentDate = () => {
    return new Date().toISOString().slice(0, 10);
};

export const createDateRangeQuery = (startDate, endDate) => {
    const startQuery = {
        value: [startDate, endDate],
        operator: 'bw',
        property: 'startDate',
    };
    const endQuery = {
        value: [startDate, endDate],
        operator: 'bw',
        property: 'endDate',
    };
    const betweenQuery = {
        operator: 'or',
        value: [startQuery, endQuery],
    };
    const startLessThanQuery = {
        value: startDate,
        operator: 'lt',
        property: 'startDate',
    };
    const endGreaterThanQuery = {
        value: endDate,
        operator: 'gt',
        property: 'endDate',
    };
    const lessThanOrEqualThan = {
        operator: 'and',
        value: [startLessThanQuery, endGreaterThanQuery],
    };
    const innerQuery = {
        operator: 'or',
        value: [betweenQuery, lessThanOrEqualThan],
    };
    return innerQuery;
};
